import RemoteConfigDefaults from '../../remoteConfigDefaults';

export const remoteConfigValues = () => {
  return RemoteConfigDefaults
}
